<template>
  <el-container class="user-center" :style="{
    minHeight: viewportHeight + 'px',
    minWidth: viewportWidth + 'px',
  }">
    <div class="user-center__layout">
      <!-- 左侧菜单 -->
      <div class="user-center__sidebar">
        <div 
          class="sidebar-item" 
          v-for="menuItem in menuConfig" 
          :key="menuItem.id"
        >
          <div 
            class="sidebar-item__header" 
            :class="{'sidebar-item__header--active': activeMenuId === menuItem.id}"
            @click="handleMenuClick(menuItem)"
          >
            <img 
              :src="activeMenuId === menuItem.id ? menuItem.activeIcon : menuItem.inactiveIcon" 
              alt="" 
              class="sidebar-item__icon" 
            />
            <span class="sidebar-item__title">{{ menuItem.title }}</span>
            <div 
              class="sidebar-item__arrow" 
              v-if="menuItem.children.length > 0"
              :class="{'sidebar-item__arrow--rotated': expandedMenuId === menuItem.id}"
            >
              <img src="../assets/image/gerenxiala.png" alt="" />
            </div>
          </div>
          
          <!-- 子菜单 -->
          <div 
            class="sidebar-item__submenu"
            v-for="submenuItem in menuItem.children" 
            :key="submenuItem.id"
            :class="{'sidebar-item__submenu--active': activeSubmenuId === submenuItem.id}"
            v-if="expandedMenuId === menuItem.id"
            @click="handleSubmenuClick(menuItem, submenuItem)"
          >
            {{ submenuItem.title }}
          </div>
        </div>
      </div>

      <!-- 右侧内容 -->
      <div class="user-center__content">
        <!-- 标签栏 -->
        <div class="tab-bar" v-if="activeMenuId !== 0">
          <div 
            class="tab-bar__item" 
            v-for="tab in tabs" 
            :key="tab.id"
            :class="{'tab-bar__item--active': activeTabId === tab.id}"
            @click="handleTabClick(tab)"
          >
            {{ tab.title }}
            <div class="tab-bar__close" @click.stop="removeTab(tab)">
              <span>×</span>
            </div>
          </div>
        </div>
        
        <!-- 动态组件区域 -->
        <component 
          :is="currentComponent"
          v-bind="componentProps"
          @accountClick="handleAccountClick"
          @withdrawClick="handleAccountClick"
          @gotoDetail="handleGotoDetail"
          @passwordEmit="getUserInfo"
          @gotoClick="handleNavigation"
        ></component>
      </div>
    </div>
  </el-container>
</template>

<script>
import http from "@/utils/http/axios";
import CommonHeader from "../components/CommonHeader.vue";
import Account from "../components/user/Account";
import Statement from "../components/user/Statement";
import Withdraw from "../components/user/Withdraw";
import TxRecord from "../components/user/TxRecord";
import AllOrder from "../components/user/AllOrder";
import BatchOrder from "../components/user/BatchOrder";
import Statistics from "../components/user/Statistics";
import Basics from "../components/user/Basics";
import PhoneManage from "../components/user/PhoneManage";
import Password from "../components/user/Password";
import WithdrawAcc from "../components/user/WithdrawAcc";
import Autonym from "../components/user/Autonym";
import Binding from "../components/user/Binding";
import BatchList from "../components/user/batchList";

// 菜单配置
const MENU_CONFIG = [
  {
    id: 0,
    title: "账户总览",
    inactiveIcon: require("@/assets/newImage/矩形@2x copy.png"),
    activeIcon: require("@/assets/newImage/矩形@2x1.png"),
    children: [],
    component: "Account"
  },
  {
    id: 1,
    title: "账户流水",
    inactiveIcon: require("@/assets/newImage/zhlsD.png"),
    activeIcon: require("@/assets/newImage/zhzlS.png"),
    children: [],
    component: "Statement"
  },
  {
    id: 2,
    title: "我要提现",
    inactiveIcon: require("@/assets/newImage/wytxD.png"),
    activeIcon: require("@/assets/newImage/wytxS.png"),
    children: [],
    component: "Withdraw"
  },
  {
    id: 3,
    title: "提现记录",
    inactiveIcon: require("@/assets/newImage/txjlD.png"),
    activeIcon: require("@/assets/newImage/txjlS.png"),
    children: [],
    component: "TxRecord"
  },
  {
    id: 4,
    title: "卖卡记录",
    inactiveIcon: require("@/assets/newImage/mkjlS.png"),
    activeIcon: require("@/assets/newImage/mkjlD.png"),
    children: [
      { id: 3.1, title: "全部订单", parentId: 4, component: "AllOrder" },
      { id: 3.2, title: "批量订单", parentId: 4, component: "BatchOrder" },
    ]
  },
  {
    id: 6,
    title: "资料管理",
    inactiveIcon: require("@/assets/newImage/zlglS.png"),
    activeIcon: require("@/assets/newImage/zlglD.png"),
    children: [
      { id: 5.1, title: "基本资料", parentId: 6, component: "Basics" },
      { id: 5.3, title: "密码管理", parentId: 6, component: "Password" },
      { id: 5.4, title: "实名认证", parentId: 6, component: "Autonym" },
      { id: 5.5, title: "提现账户", parentId: 6, component: "WithdrawAcc" },
    ]
  },
  {
    id: 7,
    title: "我的邀请",
    inactiveIcon: require("@/assets/newImage/txjlD.png"),
    activeIcon: require("@/assets/newImage/txjlS.png"),
    children: [],
    component: "BatchList"
  },
];

// 组件映射
const COMPONENT_MAP = {
  "Account": Account,
  "Statement": Statement,
  "Withdraw": Withdraw,
  "TxRecord": TxRecord,
  "AllOrder": AllOrder,
  "BatchOrder": BatchOrder,
  "Statistics": Statistics,
  "Basics": Basics,
  "PhoneManage": PhoneManage,
  "Password": Password,
  "Autonym": Autonym,
  "WithdrawAcc": WithdrawAcc,
  "Binding": Binding,
  "BatchList": BatchList
};

export default {
  name: "UserCenter",
  components: {
    CommonHeader,
    ...COMPONENT_MAP
  },
  data() {
    return {
      // 视图相关
      viewportHeight: 1080,
      viewportWidth: 1920,
      
      // 菜单状态
      activeMenuId: 0,       // 当前激活的主菜单ID
      expandedMenuId: 0,     // 当前展开的菜单ID
      activeSubmenuId: 0,    // 当前激活的子菜单ID
      activeTabId: 0,        // 当前激活的标签ID
      
      // 数据
      menuConfig: MENU_CONFIG,  // 菜单配置
      tabs: [],                 // 标签列表
      userData: null,           // 用户数据
      batchNo: '',              // 批次号
      
      // 详情数据
      detailData: {
        id: 7,
        title: "查看详情",
        inactiveIcon: '',
        activeIcon: "",
        children: [],
      }
    };
  },
  computed: {
    /**
     * 获取当前组件名称
     */
    currentComponent() {
      // 如果是子菜单项
      if (this.activeSubmenuId) {
        const submenu = this.findSubmenuById(this.activeSubmenuId);
        return submenu ? submenu.component : null;
      }
      
      // 如果是主菜单项
      const menu = this.findMenuById(this.activeMenuId);
      return menu ? menu.component : null;
    },
    
    /**
     * 获取当前组件属性
     */
    componentProps() {
      const props = {};
      
      // 账户总览、密码管理、提现账户组件需要用户数据
      if ([0, 5.3, 5.5].includes(this.activeMenuId) || [5.3, 5.5].includes(this.activeSubmenuId)) {
        props.userData = this.userData;
      }
      
      // 批次列表组件需要批次号
      if (this.activeMenuId === 7) {
        props.batchNo = this.batchNo;
      }
      
      return props;
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    /**
     * 初始化页面
     */
    initPage() {
      window.scrollTo(0, 0);
      this.updateViewportDimensions();
      this.getUserInfo();
      this.handleStoreState();
    },
    
    /**
     * 处理存储状态
     */
    handleStoreState() {
      if (this.$store.state.userChildIdX === 5.4) {
        this.activeMenuId = 6;
        this.expandedMenuId = 6;
        this.activeSubmenuId = 5.4;
      } else {
        if (this.$store.state.userIdX) {
          this.handleNavigation(this.$store.state.userIdX);
        }
        if (this.$store.state.userChildIdX) {
          this.handleNavigation(this.$store.state.userChildIdX);
        }
      }
    },

    /**
     * 处理批次详情
     */
    handleGotoDetail(batchNo) {
      this.activeMenuId = 7;
      this.activeSubmenuId = 0;
      this.expandedMenuId = 0;
      this.batchNo = batchNo;
      
      this.updateViewportDimensions();
      this.addTab(this.detailData);
    },
    
    /**
     * 处理导航
     */
    handleNavigation(id) {
      if (this.hasDecimalPoint(id)) {
        // 子菜单导航
        const submenuId = parseFloat(id);
        let parentMenu, submenuItem;
        
        if (submenuId >= 3.1 && submenuId <= 3.3) {
          // 卖卡记录子菜单
          parentMenu = this.findMenuById(4);
          submenuItem = this.findSubmenuById(submenuId);
        } else {
          // 资料管理子菜单
          parentMenu = this.findMenuById(6);
          submenuItem = this.findSubmenuById(submenuId);
        }
        
        if (parentMenu && submenuItem) {
          this.handleSubmenuClick(parentMenu, submenuItem);
        }
      } else {
        // 主菜单导航
        const menuId = parseInt(id);
        const menuItem = this.findMenuById(menuId);
        
        if (menuItem) {
          this.handleMenuClick(menuItem);
        }
      }
    },
    
    /**
     * 处理账号点击
     */
    handleAccountClick(id) {
      this.handleNavigation(id);
    },
    
    /**
     * 更新视口尺寸
     */
    updateViewportDimensions() {
      this.viewportHeight = window.innerHeight;
      this.viewportWidth = window.innerWidth;
    },
    
    /**
     * 处理标签点击
     */
    handleTabClick(tab) {
      if (this.hasDecimalPoint(tab.id)) {
        // 子菜单标签
        const submenuId = parseFloat(tab.id);
        const parentId = tab.parentId;
        
        this.activeMenuId = parentId;
        this.activeSubmenuId = submenuId;
        this.activeTabId = submenuId;
      } else {
        // 主菜单标签
        this.activeMenuId = tab.id;
        this.activeSubmenuId = 0;
        this.activeTabId = tab.id;
      }
    },
    
    /**
     * 移除标签
     */
    removeTab(tab) {
      this.tabs = this.tabs.filter(item => item.id !== tab.id);
      
      if (this.tabs.length === 0) {
        this.resetState();
        return;
      }
      
      // 选中最后一个标签
      const lastTab = this.tabs[this.tabs.length - 1];
      this.handleTabClick(lastTab);
    },
    
    /**
     * 重置状态
     */
    resetState() {
      this.activeMenuId = 0;
      this.expandedMenuId = 0;
      this.activeSubmenuId = 0;
      this.activeTabId = 0;
    },
    
    /**
     * 处理菜单点击
     */
    handleMenuClick(menuItem) {
      if (menuItem.children.length === 0) {
        // 无子菜单的项目
        if (menuItem.id === 0) {
          this.getUserInfo();
        }
        
        this.activeMenuId = menuItem.id;
        this.activeSubmenuId = 0;
        this.expandedMenuId = 0;
        
        this.addTab(menuItem);
      } else {
        // 有子菜单的项目 - 切换展开状态
        this.expandedMenuId = this.expandedMenuId === menuItem.id ? 0 : menuItem.id;
      }
    },
    
    /**
     * 处理子菜单点击
     */
    handleSubmenuClick(parentItem, submenuItem) {
      this.activeMenuId = parentItem.id;
      this.activeSubmenuId = submenuItem.id;
      this.expandedMenuId = parentItem.id;
      
      this.addTab(submenuItem);
    },
    
    /**
     * 添加标签
     */
    addTab(item) {
      // 检查标签是否已存在
      const exists = this.tabs.some(tab => tab.id === item.id);
      
      // 不添加账户总览标签和已存在的标签
      if (item.id === 0 || exists) {
        this.activeTabId = item.id;
        return;
      }
      
      // 添加新标签
      this.tabs.push(item);
      this.activeTabId = item.id;
    },
    
    /**
     * 获取用户信息
     */
    getUserInfo() {
      http.get("/user/base/info")
        .then(response => {
          if (response.code === 200) {
            this.userData = response.data;
            this.userData.phone = this.userData.mobile;
          }
        })
        .catch(() => {
          this.$message.error("发生意外异常");
        });
    },
    
    /**
     * 判断是否包含小数点
     */
    hasDecimalPoint(num) {
      return String(num).includes('.');
    },
    
    /**
     * 根据ID查找菜单项
     */
    findMenuById(id) {
      return this.menuConfig.find(item => item.id === id);
    },
    
    /**
     * 根据ID查找子菜单项
     */
    findSubmenuById(id) {
      for (const menu of this.menuConfig) {
        if (menu.children && menu.children.length > 0) {
          const submenu = menu.children.find(item => item.id === id);
          if (submenu) {
            return submenu;
          }
        }
      }
      return null;
    }
  }
};
</script>

<style lang="less">
.user-center {
  &__layout {
    height: 100%;
    display: flex;
    background-color: #ECF2FE;
    overflow: hidden;
    flex: 1;
    margin-top: 20px;
  }

  &__sidebar {
    width: 280px;
    background-color: white;
    padding-top: 20px;
    flex-shrink: 0;
  }

  &__content {
    flex: 1;
    margin-left: 25px;
    margin-right: 30px;
    margin-top: 20px;
    flex-shrink: 0;
    overflow: hidden;
  }
}

.sidebar-item {
  &__header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: rgba(72, 142, 255, 0.1);
    }

    &--active {
      background-color: #488eff;
      color: white;
    }
  }

  &__icon {
    width: 32px;
    height: 32px;
  }

  &__title {
    margin-left: 10px;
    font-size: 16px;
  }

  &__arrow {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 20px;
    width: 16px;
    display: flex;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
      transition: transform 0.3s;
    }

    &--rotated img {
      transform: rotate(180deg);
    }
  }

  &__submenu {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 74px;
    cursor: pointer;
    transition: all 0.3s;
    background-color: #f8f8f8;
    text-align: left;

    &:hover {
      background-color: rgba(72, 142, 255, 0.1);
    }

    &--active {
      background-color: rgba(72, 142, 255, 0.1);
      color: #488eff;
      position: relative;
      
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 24px;
        background-color: #488eff;
      }
    }
  }
}

.tab-bar {
  height: 43px;
  background-color: rgb(235, 237, 244);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 0px 20px;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;

  &__item {
    width: 128px;
    height: 43px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }

    &--active {
      background-color: white;
      color: #488eff;
    }
  }

  &__close {
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    span {
      font-size: 18px;
      line-height: 1;
    }
  }
}
</style>